
//import ApiService from "@/core/services/ApiService";
import { defineComponent } from "vue";
import { Field } from "vee-validate";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import * as Yup from "yup";
import { DrawerComponent } from "@/assets/ts/components/_DrawerComponent";
import ApiService from "@/core/services/ApiService";
import { VueCookieNext } from 'vue-cookie-next';

export default defineComponent({
  name: "trainee_license_info",
  components: {
    Field,
  },
  data() {
    return {
      formData: {
        id: "",
        registration_number: "",
        trainee_profile_id: "",
        license_number: "",
        application_date: "",
        given_date: "",
        expiry_date: "",
      },

      load: false,
    };
  },
  async created() {
    this.load = true;
    this.emitter.on("license_info_updated", async (data) => {
      this.formData = data;
      setTimeout(() => (this.load = false), 2000);
    });
  },
  methods: {
    async formSubmit() {
      let formData = new FormData();
      for (var key in this.formData) {
        formData.set(key, this.formData[key]);
      }
      let user_id = VueCookieNext.getCookie('_seip_user');
      formData.set('user_id', user_id.id);
      await ApiService.post("trainee/updateLicenseInfo", formData)
        .then((response) => {
          DrawerComponent?.hideAll();
          if (response.status == 200) {
            if (response.data.status == "error") {
              Swal.fire({
                title: "Error!",
                html: response.data.message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Close",
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            } else {
              Swal.fire({
                title: "Success!",
                text: response.data.data,
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Ok",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              }).then(() => {
                //this.$router.push("/sign-up");
              });
            }
          } else {
            let err = "";
            for (const field of Object.keys(response.data.errors)) {
              err += response.data.errors[field][0] + "<br>";
            }
            Swal.fire({
              title: "Please check all the required field",
              html: err,
              icon: "error",
              buttonsStyling: false,
              confirmButtonText: "Close",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        })
        .catch(({ response }) => {
          Swal.fire({
            title: "Unknown error",
            html: response.data.error,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Close",
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });
        });
    },
  },
});
